<template>
  <div class="guide">
    <section class="zero">
      <img :src="require(is1920 ? '../assets/guide00.png' : '../assets/guide28800.png')"/>
      <div class="hd">
        <p @click="() => $router.push({name: 'guide'})">充电操作指引</p>
        <p>操作简便 安全高效</p>
      </div>
    </section>
    <section class="one">
      <img :src="require(is1920 ? '../assets/guide01.png' : '../assets/guide28801.png')"/>
      <div class="desc">
        <p>一、熄火插枪</p>
        <p>车辆停稳并熄火，使用充电枪连接</p>
        <p>车辆充电口，确保连接成功</p>
      </div>
    </section>
    <section class="two">
      <img :src="require(is1920 ? '../assets/guide02.png' : '../assets/guide28802.png')"/>
      <div class="desc">
        <p>二、扫码充电</p>
        <p>扫描终端上的二维码，选择充电方式，</p>
        <p>即可点击立即充电按钮</p>
      </div>
    </section>
    <section class="three">
      <img :src="require(is1920 ? '../assets/guide03.png' : '../assets/guide28803.png')"/>
      <div class="desc">
        <p>三、实时查看</p>
        <p>开启充电后，可进入充电页面查看实</p>
        <p>时数据，可随时停止充电</p>
      </div>
    </section>
    <section class="four">
      <img :src="require(is1920 ? '../assets/guide04.png' : '../assets/guide28804.png')"/>
      <div class="desc">
        <p>四、完成支付</p>
        <p>点击停止充电按钮，结束本次充电，系</p>
        <p>统会从余额中扣款，完成支付</p>
      </div>
    </section>
    <section class="five">
      <img :src="require(is1920 ? '../assets/guide05.png' : '../assets/guide28805.png')"/>
      <div class="desc">
        <p>五、拔枪驶离</p>
        <p>请记得拔枪，将充电设备归位，</p>
        <p>并驶离充电车位</p>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'guide',
  inject: ['is1920']
}
</script>
<style lang="less">
.guide{
  img{
    width: 100%;
    height: 100%;
  }
  section{
    position: relative;
    height: 7.5rem;
  }
  .zero{
    height: 6rem;
    .hd{
      position: absolute;
      top: .75rem;
      margin-left: 8.4rem;
      p{
        color: #FFF;
        &:first-child{
          font-size: .6rem;
          line-height: .8rem;
        }
        &:last-child{
          font-size: .28rem;
          line-height: .4rem;
        }
      }
    }
  }
  .desc{
    position: absolute;
    text-align: left;
    p{
      &:nth-child(1){
        font-size: .4rem;
        line-height: .6rem;
        color: #081530;
      }
      &:nth-child(2),&:nth-child(3){
        font-size: .28rem;
        line-height: .4rem;
        color: #666;
      }
    }
  }
  .one .desc{
    top: 2.5rem;
    left: 3.6rem;
  }
  .two .desc{
    top: 3.16rem;
    left: 10.6rem;
  }
  .three .desc{
    top: 2.94rem;
    left: 3.6rem;
  }
  .four .desc{
    top: 2.66rem;
    left: 10.6rem;
  }
  .five .desc{
    top: 2.46rem;
    left: 3.6rem;
  }
}
</style>
